import { Typography, Box } from '@mui/material';
import { RenderSanityBlock } from '@/components/RenderSanityBlock';
import { CommonComponentPost } from '../CommonComponentPost';

export const DiscussionPost = ({ feedContent, comments, link }) => {
  return (
    <CommonComponentPost
      feedContent={feedContent}
      comments={comments}
      link={link}
    >
      <Box px="32px">
        {feedContent?.body &&
          (typeof feedContent?.body === 'string' ? (
            <Typography lineHeight={1.5} variant="body1" whiteSpace="pre-line">
              {feedContent.body}
            </Typography>
          ) : (
            <RenderSanityBlock blocks={feedContent.body.all} />
          ))}
      </Box>
    </CommonComponentPost>
  );
};
